import '../../styles/Form.css';
import "es6-shim";
import * as React from 'react';
import MaskedInput from "react-maskedinput";

interface IFormInputProps {
    labelText: string,
    typeOfInput?: string,
    value: string,
    placeHolder?: string,
    readOnly?: boolean,
    required?: boolean
    customInput?: JSX.Element
    fontSize?: number,
    validationMessage?: string,
    isValid?: boolean,
    mask: string,
    pipe?: any,
    focused?: boolean,
    erasable: boolean,
    onErase?(): void,
    onBlur?(): void,
    onChange?(value: string): void,
    onFocus?(): void,
    ignoreValidationBlockSpacing?: boolean;
    inputStyles?: React.CSSProperties;
}
export class LabelledMaskedInput extends React.Component<IFormInputProps, any> {
    constructor(props) {
        super(props);
    }
    public render() {
        // Setup classes for each component
        let labelClass = this.props.required ? "input-label required" : "input-label";

        let inputClassName = this.props.isValid ? "input-box" : "input-box-invalid";
        if (this.props.focused) {
            inputClassName = inputClassName + " focused";
        }
        if (this.props.required) {
            labelClass = labelClass + " required";
        }
        return (
            <div className="input-container">

                <label className={labelClass}>{this.props.labelText}</label>
                <div style={{ position: "relative" }}>
                    <MaskedInput
                        autoComplete="off"
                        style={{...this.props.inputStyles}}
                        className={inputClassName}
                        mask={this.props.mask}
                        onClick={e => { e.preventDefault(); e.stopPropagation(); }}
                        value={this.props.value}
                        onChange={(val) => this.props.onChange(val.target.value)}
                        onBlur={this.props.onBlur}
                        readOnly={this.props.readOnly}
                        placeholder={this.props.placeHolder}
                        onFocus={() => { this.props.onFocus() }}
                    />
                    {
                        this.props.value !== "" && this.props.erasable &&
                        <span
                            className="glyphicon glyphicon-remove delete-text-input "
                            aria-hidden="true"
                            onClick={() => this.props.onErase()}
                        />
                    }
                </div>
                {!this.props.ignoreValidationBlockSpacing && <span className="valid-block" style={{ visibility: this.props.isValid ? "hidden" : "visible" }}>{this.props.validationMessage}</span>}
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/customFormComponents/LabelledMaskedInput.tsx